import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: "root",
})
export class ToastService {
  constructor(private toastr: ToastrService) {}
  success(message: string, title: string = "Thành công", options: any = {}) {
    return this.toastr.success(message, title, {
      positionClass: "toast-top-right",
      toastClass: "toast ngx-toastr",
      closeButton: true,
      ...options,
    });
  }
  error(message: string, title: string = "Lỗi", options: any = {}) {
    return this.toastr.error(message, title, {
      positionClass: "toast-top-right",
      toastClass: "toast ngx-toastr",
      closeButton: true,
      ...options,
    });
  }
  warning(message: string, title: string = "Cảnh báo", options: any = {}) {
    return this.toastr.warning(message, title, {
      positionClass: "toast-top-right",
      toastClass: "toast ngx-toastr",
      closeButton: true,
      ...options,
    });
  }
  info(message: string, title: string = "Thông báo", options: any = {}) {
    return this.toastr.info(message, title, {
      positionClass: "toast-top-right",
      toastClass: "toast ngx-toastr",
      closeButton: true,
      ...options,
    });
  }
  show(message: string, title: string = "Thông báo", options: any = {}) {
    return this.toastr.show(message, title, {
      positionClass: "toast-top-right",
      toastClass: "toast ngx-toastr",
      closeButton: true,
      ...options,
    });
  }
  clear(toastId?: number) {
    this.toastr.clear(toastId);
  }
}
